import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { Selection } from '../../../elements';

const SelectionFilter = observer(({ initialValue, options, onChange, title }) => {
  
  // console.log('SelectionFilter', { initialValue, options, onChange, title })
  const [option, setOption] = useState(initialValue);

  const onSelectChange = (value, text) => {
    const option = { key: value, value, text };
    setOption(option);
    onChange(option);
  };

  return (
    <Selection
      onChange={onSelectChange}
      title={title}
      options={options}
      defaultValue={option?.value}
    />
  );
});

const optionShapePropType = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
});

SelectionFilter.propTypes = {
  initialValue: optionShapePropType,
  options: PropTypes.arrayOf(
    optionShapePropType
  ).isRequired,
  onChange: PropTypes.func,
  title: PropTypes.string,
};

SelectionFilter.defaultProps = {
  onChange: () => null,
  options: [],
  title: '',
};

export default SelectionFilter;
